module.exports = __webpack_public_path__ + "media/images/loghi/lbatv-banner-812f0fca60f50df0fe3efe56c506911c.png";